import { GPT_FEATURE, hasFeatureFlag } from '../../utilities/featureFlags';
import { RouteInfo } from './sidebar.metadata';

export const getSideBarMenu = (featureFlags?:string[]): RouteInfo[]=>{
  return [
  {
    path: '/admin/dashboard',
    title: 'dashboard',
    icon: 'mdi mdi-view-dashboard',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['consultant', 'trainer', 'admin', 'superadmin'],
    submenu: []
  },
  {
    path: 'bot-settings',
    title: 'bot',
    icon: 'mdi mdi-robot',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['admin', 'superadmin'],
    submenu: [
      {
        path: '/admin/settings/bot',
        title: 'botSettings',
        icon: 'mdi mdi-cog',
        class: '',

        label: '',
        labelClass: '',
        extralink: false,
        roles: ['admin', 'superadmin'],
        submenu: []
      },
      {
        path: '/admin/qualities',
        title: 'qualities',
        icon: 'mdi mdi-human-greeting',
        class: '',

        label: '',
        labelClass: '',
        extralink: false,
        roles: ['consultant', 'trainer', 'admin', 'superadmin'],
        submenu: []
      },
    ]
  },
  {
    path: '/admin/conversations',
    title: 'conversations',
    icon: 'mdi mdi-message',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['admin', 'superadmin'],
    submenu: []
  },
  {
    path: 'trobbit-live',
    title: 'trobbitlive.title',
    icon: 'mdi mdi-face-agent',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['admin', 'superadmin'],
    submenu: [
      {
        path: '/admin/trobbit-live/report',
        title: 'trobbitlive.report',
        icon: 'mdi mdi-chart-box',
        class: '',

        label: '',
        labelClass: '',
        extralink: false,
        roles: ['admin', 'superadmin'],
        submenu: []
      },
      {
        path: '/admin/trobbit-live/topics',
        title: 'trobbitlive.agentsTopics',
        icon: 'mdi mdi-label-multiple',
        class: '',

        label: '',
        labelClass: '',
        extralink: false,
        roles: ['admin', 'superadmin'],
        submenu: []
      },
      {
        path: '/admin/trobbit-live/templates',
        title: 'trobbitlive.agentMessage',
        icon: 'mdi mdi-tooltip-account',
        class: '',

        label: '',
        labelClass: '',
        extralink: false,
        roles: ['admin', 'superadmin'],
        submenu: []
      },
      {
        path: '/admin/trobbit-live/feedback',
        title: 'trobbitlive.liveFeedback',
        icon: 'mdi mdi-star',
        class: '',

        label: '',
        labelClass: '',
        extralink: false,
        roles: ['admin', 'superadmin'],
        submenu: []
      },
    ]
  },
  {
    path: '/admin/contacts',
    title: 'contacts',
    icon: 'mdi mdi-account',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['consultant', 'trainer', 'admin', 'superadmin', 'agent'],
    submenu: []
  },
  {
    path: '',
    title: 'knowledge.title',
    icon: 'mdi mdi-brain',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['consultant', 'trainer', 'admin', 'superadmin'],
    submenu: getKnowledgeMenu(featureFlags)
  },
  {
    path: '/admin/tables',
    title: 'tables',
    icon: 'mdi mdi-table-edit',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['admin', 'superadmin'],
    submenu: []
  },
  {
    path: '',
    title: 'marketing',
    icon: 'mdi mdi-shopping',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['admin', 'superadmin'],
    submenu: [
      {
        path: '/admin/marketing/settings/campaigns',
        title: 'manageCampaigns',
        icon: 'mdi mdi-cogs',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        roles: ['admin', 'superadmin', 'consultant', 'trainer'],
        submenu: []
      },
      {
        path: '/admin/content/folders',
        title: 'content',
        icon: 'mdi mdi-content-duplicate',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        roles: ['admin', 'superadmin', 'consultant', 'trainer'],
        submenu: []
      },
      {
        path: '',
        title: 'report',
        icon: 'mdi mdi-poll',
        class: 'has-arrow',
        label: '',
        labelClass: '',
        extralink: false,
        roles: ['admin', 'superadmin', 'consultant', 'trainer'],
        submenu: [
          {
            path: '/admin/marketing/report/campaigns',
            title: 'reportCampaigns',
            icon: 'mdi mdi-poll',
            class: '',
            label: '',
            labelClass: '',
            extralink: false,
            roles: ['admin', 'superadmin', 'consultant', 'trainer'],
            submenu: []
          },
          {
            path: '/admin/marketing/report/notifications',
            title: 'reportNotifications',
            icon: 'mdi mdi-poll',
            class: '',
            label: '',
            labelClass: '',
            extralink: false,
            roles: ['admin', 'superadmin', 'consultant', 'trainer'],
            submenu: []
          },
          {
            path: '/admin/marketing/report/consumption',
            title: 'reportConsumption',
            icon: 'mdi mdi-poll',
            class: '',
            label: '',
            labelClass: '',
            extralink: false,
            roles: ['admin', 'superadmin', 'consultant', 'trainer'],
            submenu: []
          },
        ]
      },

      // {
      //   path: '',
      //   title: 'reportCampaigns',
      //   icon: 'mdi mdi-poll',
      //   class: '',
      //   label: '',
      //   labelClass: '',
      //   extralink: false,
      //   roles: ['admin', 'superadmin'],
      //   submenu: [

      //   ]
      // }
    ]
  },

  {
    path: '/admin/integrations',
    title: 'integrations',
    icon: 'mdi mdi-apps',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['consultant', 'trainer', 'admin', 'superadmin'],
    submenu: []
  },

  {
    path: '',
    title: 'history',
    icon: 'mdi mdi-archive',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['consultant', 'trainer', 'admin', 'superadmin'],
    submenu: [
      // {
      //   path: '/admin/history',
      //   title: 'conversations',
      //   icon: 'mdi mdi-forum',
      //   class: '',
      //   label: '',
      //   labelClass: '',
      //   extralink: false,
      //   roles: ['consultant', 'trainer', 'admin', 'superadmin'],
      //   submenu: []
      // },
      {
        path: '/admin/fallbacks/list',
        title: 'fallbacks',
        icon: 'mdi mdi-message-alert',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        roles: ['consultant', 'trainer', 'admin', 'superadmin'],
        submenu: []
      },
    ]
  },
  {
    path: '',
    title: 'settings',
    icon: 'mdi mdi-settings',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['admin', 'superadmin'],
    submenu: [
      {
        path: '/admin/settings/users',
        title: 'users',
        icon: 'mdi mdi-account-group',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        roles: ['admin', 'superadmin'],
        submenu: []
      },
      {
        path: '/admin/settings/company',
        title: 'company',
        icon: 'mdi mdi-domain',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        roles: ['admin', 'superadmin'],
        submenu: []
      },
    ]
  }
  /*  {
      path: '',
      title: 'chat',
      icon: 'fas fa-comment',
      class: '',
      label: '',
      labelClass: '',
      extralink: false,
      roles: ['consultant', 'trainer', 'admin', 'superadmin'],
      submenu: [
        {
          path: '',
          title: 'waitingConversation',
          icon: 'fas fa-minus-circle',
          class: '',
          click: 'waitingConversation',
          label: '',
          labelClass: '',
          extralink: false,
          roles: ['consultant', 'trainer', 'admin', 'superadmin'],
          submenu: []
        },
        {
          path: '',
          title: 'openConversation',
          icon: 'fas fa-envelope-open ',
          class: '',
          click: 'openConversation',
          label: '',
          labelClass: '',
          extralink: false,
          roles: ['consultant', 'trainer', 'admin', 'superadmin'],
          submenu: []
        },
        {
          path: '',
          title: 'closedConversation',
          icon: 'fas fa-envelope',
          class: '',
          click: 'closedConversation',
          label: '',
          labelClass: '',
          extralink: false,
          roles: ['consultant', 'trainer', 'admin', 'superadmin'],
          submenu: []
        },
        {
          path: '',
          title: 'transfered',
          icon: 'fas fa-arrow-circle-right',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          roles: ['consultant', 'trainer', 'admin', 'superadmin'],
          submenu: []
        },
      ]
    },*/
  /*{
    path: '/admin/reports',
    title: 'reports',
    icon: 'mdi mdi-chart-bar',
    class: '',

    label: '',
    labelClass: '',
    extralink: false,
    roles: ['consultant', 'trainer', 'admin', 'superadmin'],
    submenu: []
  },*/
]
}


const getKnowledgeMenu=(featureFlags?:string[])=>{
  return hasFeatureFlag(GPT_FEATURE,featureFlags)?[{
    path: '',
    title: 'knowledge.knowledgeNlp.title',
    icon: 'mdi mdi-package',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['consultant', 'trainer', 'admin', 'superadmin'],
    submenu: [
      {
        path: '/admin/categories',
        title: 'knowledge.knowledgeNlp.categories',
        icon: 'mdi mdi-tag',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        roles: ['consultant', 'trainer', 'admin', 'superadmin'],
        submenu: []
      },
      {
        path: '/admin/intents',
        title: 'knowledge.knowledgeNlp.intents',
        icon: 'mdi mdi-message-bulleted',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        roles: ['consultant', 'trainer', 'admin', 'superadmin'],
        submenu: []
      },
      {
        path: '/admin/entities',
        title: 'knowledge.knowledgeNlp.entities',
        icon: 'mdi mdi-sitemap',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        roles: ['superadmin'],
        submenu: []
      }
    ]
  },

  {
    path: '',
    title: 'knowledge.generativeBot.title',
    icon: 'mdi mdi-package',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    roles: ['consultant', 'trainer', 'admin', 'superadmin'],
    submenu: [
      {
        path: '/admin/gpt/documents',
        title: 'knowledge.generativeBot.documents',
        icon: 'mdi mdi-file-document',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        roles: ['consultant', 'trainer', 'admin', 'superadmin'],
        submenu: []
      },
      {
        path: '/admin/gpt/websites',
        title: 'knowledge.generativeBot.webSites',
        icon: 'mdi mdi-web',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        roles: ['consultant', 'trainer', 'admin', 'superadmin'],
        submenu: []
      }
    ]
  }]:[{
  path: '',
  title: 'knowledge.knowledgeNlp.title',
  icon: 'mdi mdi-package',
  class: 'has-arrow',
  label: '',
  labelClass: '',
  extralink: false,
  roles: ['consultant', 'trainer', 'admin', 'superadmin'],
  submenu: [
    {
      path: '/admin/categories',
      title: 'knowledge.knowledgeNlp.categories',
      icon: 'mdi mdi-tag',
      class: '',
      label: '',
      labelClass: '',
      extralink: false,
      roles: ['consultant', 'trainer', 'admin', 'superadmin'],
      submenu: []
    },
    {
      path: '/admin/intents',
      title: 'knowledge.knowledgeNlp.intents',
      icon: 'mdi mdi-message-bulleted',
      class: '',
      label: '',
      labelClass: '',
      extralink: false,
      roles: ['consultant', 'trainer', 'admin', 'superadmin'],
      submenu: []
    },
    {
      path: '/admin/entities',
      title: 'knowledge.knowledgeNlp.entities',
      icon: 'mdi mdi-sitemap',
      class: '',
      label: '',
      labelClass: '',
      extralink: false,
      roles: ['superadmin'],
      submenu: []
    }
  ]
},]
}
